import * as types from "../constants/actionConstants";

const initialState = [];

function categoryTemplateListReducer(state = initialState, action) {
    switch (action.type) {
        case types.CATEGORY_TEMPLATE_LIST_GET_SUCCESS:
        case types.CATEGORY_TEMPLATE_LIST_CURRENT_GET_SUCCESS:
            return action.list;

        default:
            return state;
    }
}

export default categoryTemplateListReducer;
